import {View} from 'pacto';

import i18n from 'modules/utils/i18n';


const
	SELECTOR_LINK = 'a',
	SELECTOR_LIST = 'ul',
	ID_LIST = 'navigation',
	CLASS_INITIALIZED = 'is-initialized',
	CLASS_OPEN = 'is-open',
	CLASS_BODY = 'open-navigation',
	EVENT_MOUSEUP = 'mouseup',
	EVENT_KEYPRESS = 'keypress',
	EVENT_KEYUP = 'keyup',
	KEY_ENTER = 13,
	KEY_SPACE = 32,
	KEY_ESC = 27,
	KEY_ARROW_LEFT = 37,
	KEY_ARROW_UP = 38,
	KEY_ARROW_RIGHT = 39,
	KEY_ARROW_DOWN = 40
;


function __template(data) {
	return `<button aria-controls="${data.controls}" title="${data.title}">
		<span>${data.label}</span>
	</button>`;
}


export class Navigation extends View {

	constructor(options) {
		super(options);

		this._openedState = {
			label: i18n.t('ui.navigation.close'),
			title: i18n.t('ui.navigation.hide')
		};
		this._closedState = {
			label: i18n.t('ui.navigation.open'),
			title: i18n.t('ui.navigation.show')
		};

		this._onToggle = this._onToggle.bind(this);
		this._onKeyUp = this._onKeyUp.bind(this);
		this._onToggleSubmenu = this._onToggleSubmenu.bind(this);
		this._onFocus = this._onFocus.bind(this);
		this._onBlur = this._onBlur.bind(this);
	}

	get isOpen() {
		return !!this._isOpen;
	}

	set isOpen(value) {
		value = !!value;

		if (value === this._isOpen) {
			return;
		}

		const
			html = document.documentElement,
			state = value ? this._openedState : this._closedState
			// notValue = !value,
			// tabIndex = -1 * Number(notValue)
		;

		this._isOpen = value;

		this.el.classList[value ? 'add' : 'remove'](CLASS_OPEN);
		document.body.classList[value ? 'add' : 'remove'](CLASS_BODY);

		this._button.title = state.title;
		this._button.firstElementChild.textContent = state.label;

		// this._list.setAttribute('aria-hidden', notValue);
		// this._list.inert = notValue;

		// this._links.forEach(item => item.tabIndex = tabIndex);

		value ?
			html.addEventListener(EVENT_KEYUP, this._onKeyUp) :
			html.removeEventListener(EVENT_KEYUP, this._onKeyUp);
	}

	render() {
		this.el.innerHTML += __template({controls: ID_LIST, ...this._closedState});

		this._list = this.el.querySelector(SELECTOR_LIST);
		this._list.id = ID_LIST;
		this._links = [...this._list.querySelectorAll(SELECTOR_LINK)];

		this._button = this.el.lastElementChild;
		this._button.addEventListener(EVENT_MOUSEUP, this._onToggle);
		this._button.addEventListener(EVENT_KEYPRESS, this._onToggle);
		this.isOpen = false;

		this.submenu = Array.from(this.el.querySelectorAll('.has-children'));
		this.submenu.forEach(el => el.addEventListener('click', this._onToggleSubmenu));
		this.submenu.filter(el => el.classList.contains('is-current')).forEach(el => el.classList.add(CLASS_OPEN));

		this.focusable = Array.from(this.el.querySelectorAll('.has-children > a, .navigation-submenu a'));
		this.focusable.forEach(el => {
			el.addEventListener('focus', this._onFocus);
			el.addEventListener('blur', this._onBlur);
		});

		this.el.classList.add(CLASS_INITIALIZED);

		return this;
	}

	destroy() {
		this._button && this._button.removeEventListener(EVENT_MOUSEUP, this._onToggle);
		this._button && this._button.removeEventListener(EVENT_KEYPRESS, this._onToggle);
		document.documentElement.removeEventListener(EVENT_KEYUP, this._onKeyUp);
		this.submenu?.forEach(el => el.removeEventListener('click', this._onToggleSubmenu));
		this.focusable?.forEach(el => {
			el.removeEventListener('focus', this._onFocus);
			el.removeEventListener('blur', this._onBlur);
		});

		this._list = null;
		this._links = null;
		this._button = null;

		this.observer && this.observer.disconnect();
	}

	_notify(state, data = {}) {
		this.context.trigger('navigation:' + state, data);
	}

	_focus(index) {
		const {length} = this._links;

		if (index < 0) {
			index = length - 1;
		} else if (index >= length) {
			index = 0;
		}

		this._links[index].focus();
	}

	_onToggle(event) {
		if (event.type === EVENT_KEYPRESS &&
			event.keyCode !== KEY_SPACE &&
			event.keyCode !== KEY_ENTER) {
			return;
		}

		this.isOpen = !this.isOpen;

		if (event.type === EVENT_KEYPRESS && this.isOpen) {
			//Focus the first item when using keyboard navigation:
			this._links[0].focus();
		}

		this._notify(this.isOpen ? 'open' : 'close');
	}

	_onKeyUp(event) {
		const __index = () =>
			this._links.findIndex((item) =>
				item === document.activeElement
			);

		switch (event.which) {
			case KEY_ESC:
				this.isOpen = false;
				this._button.focus();
				this._notify('close', {type: 'esc'});
				break;
			case KEY_ARROW_LEFT:
			case KEY_ARROW_UP:
				this._focus(__index() - 1);
				event.preventDefault();
				break;
			case KEY_ARROW_RIGHT:
			case KEY_ARROW_DOWN:
				this._focus(__index() + 1);
				event.preventDefault();
				break;
		}
	}

	_onToggleSubmenu(e) {
		const
			li = e.target.closest('.has-children') || e.target,
			a = li.querySelector('a')
		;

		// Only toggle when clicking on the link
		if (e.target === a || e.target.closest('a') === a) {
			e.preventDefault();
			li.classList.toggle('is-open');
		}
	}

	_onFocus(e) {
		(e.target.closest('.has-children') || e.target).classList.add('is-focused');
	}

	_onBlur(e) {
		(e.target.closest('.has-children') || e.target).classList.remove('is-focused');
	}

}
